import {
  cloneElement,
  forwardRef,
  isValidElement,
  type ReactElement,
  type Ref,
} from "react";

import { cn } from "@/ui/lib";
import {
  ITEM_CLASS,
  ITEM_DEFAULTS,
  ITEM_VARIANT_CLASS_MAP,
  TItemChildProps,
  TItemProps,
} from "@/ui/components/data-display/Item/Item.config";

export const Item = forwardRef<HTMLElement, TItemProps>(
  (
    {
      variant = ITEM_DEFAULTS.variant,
      size = ITEM_DEFAULTS.size,
      asChild = ITEM_DEFAULTS.asChild,
      className,
      children,
      ...props
    },
    ref,
  ) => {
    const itemClassName = cn(
      ITEM_CLASS,
      ITEM_VARIANT_CLASS_MAP[variant],
      className,
    );

    const sharedProps = {
      "data-component": "Item",
      "data-variant": variant,
      "data-size": size,
    };

    if (asChild && isValidElement(children)) {
      const child = children as ReactElement<TItemChildProps>;

      return cloneElement(child, {
        ...props,
        ref,
        ...sharedProps,
        className: cn(itemClassName, child.props.className),
      });
    }

    return (
      <div
        {...props}
        ref={ref as Ref<HTMLDivElement>}
        {...sharedProps}
        className={itemClassName}
      >
        { children }
      </div>
    );
  },
);

Item.displayName = "Item";
